export default import.meta.ROLLDOWN_FILE_URL_MUDP4jc8NhHDmzQ56_cGyQ